import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { CRM_TYPE } from '../utils/crmType';

const firebaseConfigs: Record<string, {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}> = {
  emploi: {
    apiKey: "AIzaSyDLqmwvD6u0HA9jXzxuNIBceJMSY5j_4mU",
    authDomain: "bdd-crm-emploi.firebaseapp.com",
    projectId: "bdd-crm-emploi",
    storageBucket: "bdd-crm-emploi.firebasestorage.app",
    messagingSenderId: "137239504456",
    appId: "1:137239504456:web:ee25b5aef7197a3701da7d"
  },
  reclassement: {
    apiKey: "AIzaSyCf4XlgPYKqMJQmI1kHZqEHRUo_JgIu7nw",
    authDomain: "bdd-crm-relassement.firebaseapp.com",
    projectId: "bdd-crm-relassement",
    storageBucket: "bdd-crm-relassement.firebasestorage.app",
    messagingSenderId: "493055818176",
    appId: "1:493055818176:web:a76d30f32413076c113025"
  }
};

const firebaseConfig = firebaseConfigs[CRM_TYPE] || firebaseConfigs.emploi;

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app, `gs://${firebaseConfig.storageBucket}`);
export const functions = getFunctions(app);

export default app;
